import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState, DwActionState } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, StudentCourseEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../../courses/models/course-progress-variable-context.model";
import { StudentAssignmentProgressEvent, studentAssignmentProgress } from "../models/student-assignment-progress-event.model";
import { SchoolRepositoryService } from "../services/school-repository.service";
import { ResetStudentAssignmentRequest } from "../models/reset-student-assignment-request.model";
import { StudentCourseProgressRequest } from "../models/student-course-progress-request.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { StudentCourseEndorsementActionModalComponent } from "../components/student-course-endorsement-action-modal/student-course-endorsement-action-modal.component";
import { SchoolCourseEndorsementActionResult } from "../models/school-course-endorsement-action-result.model";

@DwAction({
    keyName: 'student-course-endorsement-action',
    display: 'Student Course Endorsement Action Modal',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.StudentCourse,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Endorsement Actions',
        iconClass: 'fa fa-eraser',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Handle endorsement actions for this student course'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: AppPermissions.studentCourseCanResetProgress,
        requireCanUpdate: true
    },
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false,
        message: 'Are you sure?  This cannot be undone!',
        title: 'Reset Course Progress for Student'
    }
})
@Injectable()
export class StudentCourseEndorsementActionService implements DwMdFormActionHandler {
    formApi: DwMetaDataFormApi;
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private schoolRespositoryService: SchoolRepositoryService,
        private dwEventService: DwEventService
    ) {

    }

    handleAction(actionState: DwMdFormActionState<any>): Observable<DwActionResult> {

        this.formApi = actionState.formApi;
        const studentCourse = actionState.formApi.getFormData<StudentCourseEntity>();


        return this.showModal(actionState, studentCourse);
    }

    private showModal(actionState: DwActionState<any>, studentCourse: StudentCourseEntity): Observable<DwActionResult> {
        let modalConfig = new DwModalConfig();

        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;

        modalConfig.buttons[0].buttonText = 'Execute Action';
        modalConfig.buttons[1].buttonText = 'Cancel';

        modalConfig.allowFullScreen = false;
        modalConfig.modalSize = DwModalSize.medium;
        modalConfig.data = studentCourse;
        // modalConfig.customModalWidth = '400px';
        // modalConfig.customModalHeight = '300px';

        modalConfig.component = StudentCourseEndorsementActionModalComponent;

        modalConfig.title = 'Endorsement Actions';

        return this.dwModalService.showModal<any, SchoolCourseEndorsementActionResult>(modalConfig)
            .pipe(map(modalResult => {
                const result = new DwActionResult();

                if (modalResult.cancelled) {
                    result.cancelled = true;

                    return result;
                }

                this.formApi.cancel();

                // this.formApi.loadData(true)
                //     .subscribe(() => {
                //         console.log('Data loaded after endorsement action');
                //     });

                result.success = true;
                result.message = modalResult.data?.Message || 'Endorsement action completed successfully';

                return result;
            }));
    }
}